export default __webpack_public_path__ + "static/media/background_grey.419bd38a.png";